import { Box, IconButton, Link, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import { PropsWithChildren } from 'react';
import ArrowBack from '@mui/icons-material/ArrowBack';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { branding } from '../branding';

interface MenubarProps {
  breadcrumb?: string;
  closeMenu?: () => void;
}

export const Menubar = ({ breadcrumb, children }: PropsWithChildren<MenubarProps>) => {
  const theme = useTheme();
  const { logo } = branding;
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isSmallerScreen = useMediaQuery(theme.breakpoints.down('lg'));

  return (
    <Stack direction="column">
      {!isMobile && (
        <Box textAlign="center" height="100px">
          <Link href="/">
            <Box component="img" src={logo} sx={{ height: '32px' }} my="34px" />
          </Link>
        </Box>
      )}
      {breadcrumb ? (
        <Stack px={isSmallerScreen ? 1 : 2} direction="row" alignItems="center" gap={1} mb={2} mt={isMobile ? 2 : 0}>
          <IconButton href="/" color="secondary" sx={{ borderRadius: 1, border: `1px solid ${theme.palette.grey[300]}` }}>
            <ArrowBack sx={{ width: 20, height: 20 }} />
          </IconButton>
          <ArrowForwardIosIcon color="secondary" sx={{ width: 16, height: 16 }} />
          <Typography fontSize={16}>{breadcrumb}</Typography>
        </Stack>
      ) : (
        <></>
      )}
      {children}
    </Stack>
  );
};
